import { Link } from "react-router-dom";

export default function UsageMeter({ usage }) {
  if (!usage) return null;
  const { limits } = usage;
  const free = usage.plan === "free";
  const used = free ? usage.docs_total : usage.uploads_month;
  const cap = free ? limits.docs_total : limits.uploads_month;
  const pct = cap ? Math.min(100, Math.round((used / cap) * 100)) : 0;
  const full = cap != null && used >= cap;
  return (
    <div data-testid="usage-meter" className={`border p-4 flex flex-wrap items-center gap-x-6 gap-y-2 ${full ? "border-primary bg-primary/5" : "border-border"}`}>
      <div className="min-w-[200px] flex-1">
        <div className="flex items-baseline justify-between mb-1.5">
          <span className="font-mono-label text-muted-foreground">{free ? "Documents" : "Uploads this month"}</span>
          <span data-testid="usage-count" className="text-sm font-medium">{used.toLocaleString()} / {cap?.toLocaleString()}</span>
        </div>
        <div className="h-1.5 bg-muted overflow-hidden">
          <div data-testid="usage-bar" className={`h-full transition-[width] duration-500 ${full ? "bg-primary" : "bg-foreground"}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
      <span data-testid="usage-file-cap" className="text-sm text-muted-foreground">Up to {limits.max_mb} MB per file</span>
      {full && (
        <Link to="/#pricing" data-testid="usage-upgrade-link" className="text-sm text-primary underline underline-offset-4">
          {free ? "Upgrade for more documents" : "Upgrade for more uploads"}
        </Link>
      )}
    </div>
  );
}
